// Youssef Selkani
// 2019

import React, { Component } from 'react'
import '../App.css'
import { Grid, Image } from 'semantic-ui-react'
import androidapp from '../assets/androidapp.png'
import iosapp from '../assets/iosapp.png'

export default class MobileApp extends Component {
  render () {
    return (
      <div className='mt'>
        <div className='mb center'>
          <h3>Preview your app in real time</h3>
        </div>
        <Grid verticalAlign='top' textAlign='center' stackable>
          <Grid.Column width='5'>
            <Image
              centered
              src={androidapp}
              size='small'
              target='_blank'
              href='https://play.google.com/store/apps/details?id=org.usfslk.murkstom'
            />
          </Grid.Column>
          <Grid.Column width='5'>
            <Image centered src={iosapp} size='small' />
            <p>Coming soon...</p>
          </Grid.Column>
        </Grid>
      </div>
    )
  }
}
